module.exports = {
          srcSet: __webpack_public_path__ + "6fe4c4c17ac09e30d123f57b1daf3880-628.png"+" 628w",
          images:[ {path: __webpack_public_path__ + "6fe4c4c17ac09e30d123f57b1daf3880-628.png",width: 628,height: 400}],
          src: __webpack_public_path__ + "6fe4c4c17ac09e30d123f57b1daf3880-628.png",
          toString:function(){return __webpack_public_path__ + "6fe4c4c17ac09e30d123f57b1daf3880-628.png"},
          
          width: 628,
          height: 400
        }